import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Notification from '../components/Notification';
import {
  removeNotification,
  startClosingNotification,
} from '../redux/actions/NotificationActions';
import StoreCollection from '../models/StoreCollection';

const fadeOutAnimationDuration = 1000;
const defaultNotificationDuration = 10;

const mapStateToProps = (state) => ({
  notifications: new StoreCollection(state.global.notifications),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  removeNotification,
  startClosingNotification,
}, dispatch);

export class NotificationsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timers: [],
    };
  }

  componentDidUpdate() {
    this.updateTimers();
  }

  closeNotificationAfterTimer = ({ id, delay }) => {
    setTimeout(() => {
      this.closeNotification({ id });
    }, delay);
  };

  closeNotification = ({ id }) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.notifications.has(id) && !this.props.notifications.find(id).isClosing) {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.startClosingNotification({ id });
      setTimeout(() => {
        this.removeNotification({ id });
      }, fadeOutAnimationDuration);
    }
  };

  removeNotification = ({ id }) => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.removeNotification({ id });
    this.removeFromTimers(id);
  };

  addRemoveNotificationTimer = (notification) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.timers.indexOf(notification.id) === -1) {
      // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
      const timers = [...this.state.timers, notification.id];
      this.setState({
        timers,
      });
      this.closeNotificationAfterTimer({
        id: notification.id,
        delay: ((notification.duration || defaultNotificationDuration) * 1000) - fadeOutAnimationDuration,
      });
    }
  };

  removeFromTimers = (notificationId) => {
    // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
    const timers = [...this.state.timers];
    timers.splice(timers.indexOf(notificationId), 1);
    this.setState({
      timers,
    });
  };

  updateTimers = () => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.notifications.loop((notification) => {
      this.addRemoveNotificationTimer(notification);
    });
  };

  render() {
    return (
      <div className="global_messages">
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.props.notifications.map((notification) => (
          <Notification
            key={notification.id}
            {...notification}
            onClose={this.closeNotification}
          />
        ))}
      </div>
    );
  }
}

NotificationsContainer.propTypes = {
  notifications: PropTypes.instanceOf(StoreCollection),
  removeNotification: PropTypes.func,
  startClosingNotification: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsContainer);
